import IconProps from "./icon-props";

export default function CloseButton({ className }: IconProps) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M22.5 7.5L7.5 22.5" stroke="#000F33" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 7.5L22.5 22.5" stroke="#000F33" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}